export enum ActiveTabTypeE {
  Tickets = 'tickets',
  Schedule = 'schedule',
  Insights = 'insights',
}
